import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Modal } from 'shared/ui/Modal';

interface ConfirmationModalProps {
  handleApproveModal: () => void;
  handleCloseModal: () => void;
  title: string;
  description: string;
  isModalOpen: boolean;
  isSaving: boolean;
  approveNameButton: string;
  approveButtonColor?: string;
}

export const ConfirmationModal = ({
  handleApproveModal,
  handleCloseModal,
  title,
  description,
  isModalOpen,
  isSaving = false,
  approveNameButton,
  approveButtonColor,
}: ConfirmationModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      disabled={isSaving}
      isModalOpen={isModalOpen}
      isLoading={isSaving}
      handleCloseModal={handleCloseModal}
      handleSubmitModal={handleApproveModal}
      approveNameButton={approveNameButton}
      approveButtonColor={approveButtonColor}
    >
      <Box sx={{ width: 400 }}>
        <Typography
          sx={{
            fontFamily: 'OpenSans',
            fontSize: '16px',
            lineHeight: '20px',
            fontWeight: 700,
            letterSpacing: '0.14px',
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            marginY: '24px',
            fontFamily: 'OpenSans',
            fontSize: '15px',
            lineHeight: '20px',
            fontWeight: 400,
            letterSpacing: '0.14px',
          }}
        >
          {description}
        </Typography>
      </Box>
    </Modal>
  );
};
